<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="documentType.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Описание</label>
            <crm-input-text
              [(value)]="documentType.description"
              [isError]="$any(errors?.description)"></crm-input-text>
            <small
              *ngIf="errors?.description"
              class="p-error">
              {{ errors.description | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Код</label>
            <crm-input-text
              [(value)]="documentType.code"
              [isError]="$any(errors?.code)"></crm-input-text>
            <small
              *ngIf="errors?.code"
              class="p-error">
              {{ errors.code | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Тип</label>
            <crm-document-calculation-method-single-select
              [(documentMethod)]="documentType.method"
              [isError]="!!errors?.method"
              appendTo="body"></crm-document-calculation-method-single-select>
            <small
              *ngIf="errors?.method"
              class="p-error">
              {{ errors.method | join }}
            </small>
          </div>
        </div>
      </p-card>

      <div
        class="mt-3"
        *ngIf="formStoreService.getState.forms[this.index]?.isEdit">
        <crm-directory-common-history
          [entityName]="DirectoryCommonHistoryTypeEnum.DOCUMENT_TYPE"
          [entityId]="formStoreService.getState.forms[this.index]?.entityId"
          [apiService]="documentTypeService">
        </crm-directory-common-history>
      </div>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveDocumentType()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteDocumentType()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
